import { useContext } from "react";
import { BrowserRouter } from "react-router-dom";
import { DataContext } from "../context/DataContext";
import { Header } from "../components/Header";
import { Tab, TabsWrapper } from "../components/Stake/style";
import { WeeklyRewardAllocations } from "../components/WeeklyRewardAllocations";
import { AuthContext } from "../context/AuthContext";
import { GlobalStyle } from "../style";
import { SPACING } from "../constants/design/spacing";
import { IRewardVolumeAllocationRule } from "../hooks/api/admin/useRewardVolumeAllocations";

const previewRules: IRewardVolumeAllocationRule[] = [
  {
    source_account: "0x7b19b83dc868cdd41569a924550efe92b27cbf2e",
    allocations: [
      {
        account: "0x012a3bbe87ad07222a6dcd031ec60eb17a23de77",
        basis_points: 7000,
      },
      {
        account: "0x12b94ed117e6aa241a6bb3c91b4cd59693e17b79",
        basis_points: 3000,
      },
    ],
  },
  {
    source_account: "0xaa886655252e5b6e7612a49863ab1293af96be12",
    allocations: [
      {
        account: "0x63bd02fa1f4bf6230426970472930220c50f3534",
        basis_points: 10000,
      },
    ],
  },
  {
    source_account: "0xf8368119bb1073cf01b841848725d81b542a4c19",
    allocations: [
      {
        account: "0xd7d1580a09a1bb4c466295432045e2702ae71c2f",
        basis_points: 5500,
      },
      {
        account: "0x77d45b05ee88929c496bfe01265b826d8b927c62",
        basis_points: 2500,
      },
    ],
  },
  {
    source_account: "0x0a888bb1cb72f2ba9279574a6d83744d052d95fd",
    allocations: [
      {
        account: "0x83fb69fdf97d0766a372864da61f5eddf26f2c14",
        basis_points: 8000,
      },
    ],
  },
  {
    source_account: "0x98d03125c62dae2328d9d3cb32b7b969e6a87787",
    allocations: [
      {
        account: "0x23bc411c4387af7ed09d41fceb1e783e278756f5",
        basis_points: 6000,
      },
      {
        account: "0xceb3d89ed0fbf2acebff36e2fb23dacb79baf9e7",
        basis_points: 2000,
      },
    ],
  },
];

const previewAuth = {
  tokenId: "",
  setTokenId: () => undefined,
  authenticate: async () => undefined,
  queryConfig: () => ({ headers: {} }),
  isAuthenticating: false,
  redirectURL: undefined,
  setRedirectURL: () => undefined,
  userEmail: "preview@aevo.xyz",
};

const previewTags = {
  "0x7B19b83dC868CDD41569A924550efE92B27cBF2e": "Preview source",
  "0x012a3BbE87Ad07222a6dcD031EC60Eb17a23de77": "Preview recipient",
};

export function WeeklyRewardsPreview() {
  const dataContext = useContext(DataContext);
  return (
    <BrowserRouter>
      <AuthContext.Provider value={previewAuth}>
        <GlobalStyle />
        <div style={{ height: "100vh", overflow: "hidden" }}>
          <Header />
          <main style={{ padding: SPACING.four }}>
            <TabsWrapper>
              <Tab isActive>Weekly Allocation</Tab>
              <Tab isActive={false}>Staking</Tab>
              <Tab isActive={false}>Trading</Tab>
              <Tab isActive={false}>Buybacks and Burns</Tab>
            </TabsWrapper>
            <DataContext.Provider
              value={{ ...dataContext, records: previewTags }}
            >
              <WeeklyRewardAllocations
                initialTool="volume-routing"
                previewRules={previewRules}
              />
            </DataContext.Provider>
          </main>
        </div>
      </AuthContext.Provider>
    </BrowserRouter>
  );
}
